import AScrollButton from './a-scroll-button';

export default AScrollButton;